import moment from "moment";

export const dateToStringFilter = (value: string, displayTime = false): string => {
    if (value) {
        return moment(value).format(`DD MMM YYYY${displayTime ? "- HH:mm" : ""}`);
    } else {
        return "";
    }
};
